/*
 * (C) Behaviour Interactive Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * This file is proprietary and confidential
 */

import classNames from 'classnames';
import { useGlobalStore } from '../../stores/global/global.store';
import { Alert } from '../../ui-library/Patterns/Alert';
import { Toast } from '../../ui-library/Patterns/Toast';

const AppNotifications = () => {
  const { banner, notification, setBanner, setNotification } = useGlobalStore();

  const bannerClasses = classNames('relative top-0 left-0 right-0 z-50 lg:sticky', 'w-full', 'pointer-events-none');

  const notificationrClasses = classNames(
    'fixed bottom-0 left-0 right-0 z-50',
    'w-full 3xl:max-w-content',
    'px-4 sm:px-10 2xl:px-24 3xl:px-0 pb-10',
    'pointer-events-none',
    'mx-auto',
  );

  return (
    <>
      <div className={bannerClasses}>
        <Alert
          description={banner?.description}
          display={banner?.display || false}
          title={banner?.title}
          theme={banner?.theme}
          className='pointer-events-auto'
          actionButton='close'
          onClose={() => {
            setBanner(undefined);
          }}
        >
          {banner?.children}
        </Alert>
      </div>
      <div className={notificationrClasses}>
        <Toast
          description={notification?.description}
          display={notification?.display || false}
          title={notification?.title}
          theme={notification?.theme}
          timeout={notification?.timeout}
          className='pointer-events-auto'
          onClose={() => {
            setNotification(undefined);
          }}
        />
      </div>
    </>
  );
};

export default AppNotifications;
